export default {
    'menu': {
        'inicio': 'Inicio',
        'pacientes': 'Pacientes',
        'calendario': 'Calendario',
        'settings': 'Configuración',
        'crear_paciente': 'Crear un paciente',
        'crear_cita': 'Crear nueva cita',
        'abrir_cita': 'Abrir una cita',
        'abrir_ficha': 'Abrir una ficha',
        'patologias':'Patologias',
    }
}